// Submission state machine — MIRROR of the backend's
// backend/go/appfactory/internal/domain/submissionstate.go (submissionNext).
// The server remains the authority (an illegal transition gets a 422, a stale
// one a 409); this mirror only drives the operator console's dropdowns and
// ordering key so the operator never has to remember the edges. If an edge
// changes there, change it here (the vitest pins the full map).

export const SUBMISSION_STATES = [
  'preparing',
  'awaiting_customer',
  'submitting',
  'in_review',
  'approved',
  'rejected',
  'live',
  'superseded',
] as const;

export type SubmissionState = (typeof SUBMISSION_STATES)[number];

export const SUBMISSION_NEXT: Record<SubmissionState, readonly SubmissionState[]> = {
  preparing: ['awaiting_customer'],
  awaiting_customer: ['submitting'],
  submitting: ['in_review'],
  in_review: ['approved', 'rejected'],
  approved: ['live'],
  rejected: [],
  live: ['superseded'],
  superseded: [],
};

/** States that can be the FROM of a recorded transition (have successors). */
export const TRANSITIONABLE_STATES: readonly SubmissionState[] = SUBMISSION_STATES.filter(
  (s) => SUBMISSION_NEXT[s].length > 0,
);

/** Legal TO states for a given FROM ([] for terminal/unknown). */
export function legalNextStates(from: string): readonly SubmissionState[] {
  return SUBMISSION_NEXT[from as SubmissionState] ?? [];
}
